export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  KANBAN_CARD_MOVED: 'KANBAN_CARD_MOVED',
  // CRM-01h fase 3: um "mover em bloco" terminou; o quadro recarrega uma vez.
  KANBAN_BOARD_CHANGED: 'KANBAN_BOARD_CHANGED',
  KANBAN_PIPELINES_CHANGED: 'KANBAN_PIPELINES_CHANGED',
  // CRM-04 R2-T7: a face do negócio mudou sem mover, e dois negócios viraram um.
  KANBAN_CARD_UPDATED: 'KANBAN_CARD_UPDATED',
  KANBAN_CARD_MERGED: 'KANBAN_CARD_MERGED',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  // O aviso de janela de 24 h fica no MessagesView e o modal de disparo vive no
  // ReplyBox. Sao componentes diferentes, e e' o ReplyBox que ja tem o estado do
  // modal -- entao o aviso PEDE a abertura por aqui em vez de montar um segundo
  // modal so para ele.
  OPEN_OUTBOUND_TEMPLATES: 'OPEN_OUTBOUND_TEMPLATES',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
};
